// i18nOwl-ignore [app-cohort.triggerIntegrations.be-in-cohort.title]
import type {TriggerIntegration} from '@cohort/merchants/apps';
import CohortBeInCohortTriggerkIntegrationConfigComponent from '@cohort/merchants/apps/cohort/triggerIntegrations/beInCohort/ConfigComponent';
import CohortBeInCohortTriggerIntegrationStepCompletionTitleComponent from '@cohort/merchants/apps/cohort/triggerIntegrations/beInCohort/StepCompletionTitleComponent';
import type {CohortBeInCohortTriggerStruct} from '@cohort/shared/schema/apps/cohort/triggers/beInCohort';
import {CohortBeInCohortTriggerIntegrationSpec} from '@cohort/shared/schema/apps/cohort/triggers/beInCohort';

export const CohortBeInCohortTriggerIntegration: TriggerIntegration<CohortBeInCohortTriggerStruct> =
  {
    spec: CohortBeInCohortTriggerIntegrationSpec,
    configComponent: CohortBeInCohortTriggerkIntegrationConfigComponent,
    stepCompletionTitleComponent: CohortBeInCohortTriggerIntegrationStepCompletionTitleComponent,
  };
